import {
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Colorpicker} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$cc(Colorpicker, {
        'disabled': true,
        'ev-$model:value': function($v) {
            $this.set('color', $v);
        },
        'value': $this.get('color')
    });
};